import { render, staticRenderFns } from "./NewTag.vue?vue&type=template&id=3c586607&scoped=true&"
import script from "./NewTag.vue?vue&type=script&lang=js&"
export * from "./NewTag.vue?vue&type=script&lang=js&"
import style0 from "./NewTag.vue?vue&type=style&index=0&id=3c586607&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c586607",
  null
  
)

export default component.exports